document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(event) {
        if (event.target.closest(".slider-custom--btn--right")) {
            const sliderCustom = event.target.closest(".shopify-section");
            let container2 = sliderCustom.querySelector('.testimonials-new__main .featured__collection-carousel');
            const sliderLeft = sliderCustom.querySelector(".slider-custom--btn--left");
          const sliderLeft2 = sliderCustom.querySelector(".testomonial-btn--mobile .slider-custom--btn--left");

            if (sliderLeft) {
                sliderLeft.classList.remove('non_active');
            }
          if(sliderLeft2){
            sliderLeft2.classList.remove('non_active');
          }

            if (sliderCustom) {
                const nextButton = sliderCustom.querySelector(".flickity-prev-next-button.next");
                if (nextButton) {
                    nextButton.click();
                }
            }

            updateCustomDots(container2, sliderCustom);
        }
    });

    document.addEventListener("click", function(event) {
        if (event.target.closest(".slider-custom--btn--left")) {
            const sliderCustom = event.target.closest(".shopify-section");
            let container2 = sliderCustom.querySelector('.testimonials-new__main .featured__collection-carousel');

            if (sliderCustom) {
                const prevButton = sliderCustom.querySelector(".flickity-prev-next-button.previous");
                if (prevButton) {
                    prevButton.click();
                }
            }

            updateCustomDots(container2, sliderCustom);
        }
    });

    function updateCustomDots(container2, sliderCustom) {
        if (!container2 || !sliderCustom) return;

        const originalDots = container2.querySelectorAll('.flickity-page-dots li');
        const customDots = sliderCustom.querySelectorAll('.flickity-page-dots-custom li');
      const customDots2 = sliderCustom.querySelectorAll('.testomonial-btn--mobile .flickity-page-dots-custom li');

        if (originalDots.length === 0 || customDots.length === 0) return;

        originalDots.forEach((dot, index) => {
            if (dot.classList.contains("is-selected")) {
                customDots.forEach(dot => dot.classList.remove("is-selected"));
                if (customDots[index]) {
                    customDots[index].classList.add("is-selected");
                }
              if (customDots2[index]) {
                    customDots2[index].classList.add("is-selected");
                }
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".flickity-page-dots-custom").forEach(customDotsContainer => {
        customDotsContainer.querySelectorAll("li").forEach((customDot, index) => {
            customDot.addEventListener("click", function () {
                let container = customDot.closest(".shopify-section");

                if (!container) return; // Ensure the section exists

                let carousel = container.querySelector('.testimonials-new__main .featured__collection-carousel');

                if (carousel) {
                    let dots = carousel.querySelectorAll(".flickity-page-dots li");

                    if (dots[index]) {
                        dots[index].click();
                    }
                }

                // Remove "is-selected" class from all siblings
                customDotsContainer.querySelectorAll("li").forEach(dot => {
                    dot.classList.remove("is-selected");
                });

                // Add "is-selected" class to the clicked li
                customDot.classList.add("is-selected");
            });
        });
    });
});



